const INSET = -1;
const MIN_SIZE = 1 - INSET * 2;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function rootMargin(rect: DOMRect, rootBounds: DOMRect): string {
  const width = Math.max(rect.width, MIN_SIZE);
  const height = Math.max(rect.height, MIN_SIZE);

  const top = rect.top - rootBounds.top - INSET;
  const left = rect.left - rootBounds.left - INSET;
  const right = rootBounds.right - rect.left - width - INSET;
  const bottom = rootBounds.bottom - rect.top - height - INSET;

  return `${-Math.round(top)}px ${-Math.round(right)}px ${-Math.round(bottom)}px ${-Math.round(left)}px`;
}
